import React, { ReactElement, useEffect } from 'react';
import { importSites } from '../../../redux/actions/siteActions';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../redux/reducers';
import { Box, DialogContent } from '@mui/material';
import SiteAutocomplete from '../../../common/components/autocomplete/SiteAutocomplete';

import { FormDialogTitle } from '../../../common/components/form/FormPrimitives';

import { ResponsiveDialog } from '../../../common/components/mobile/MobilePrimitives';

type ChooseSiteType = {
    open: boolean;
    closeForm(): void;
};

export default function ChooseSite(props: ChooseSiteType): ReactElement {
    const { open, closeForm } = props;

    const sites = useAppSelector((state: RootState) => state.sites.sites);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!sites) {
            dispatch(importSites());
        }
    }, [dispatch]);

    const handleSelectSite = (siteId?: number) => {
        if (!!siteId) {
            closeForm();
            navigate(siteId.toString() + '/goodsToSiteForm');
        }
    };

    return (
        <div>
            <ResponsiveDialog scroll="body" maxWidth="md" open={open} onClose={closeForm}>
                <FormDialogTitle>Izaberi skladište</FormDialogTitle>
                <DialogContent dividers sx={{ px: { xs: 2, sm: 5 }, pt: { xs: 3, sm: 5 } }}>
                    <Box sx={{ minWidth: { xs: '50vw', sm: 300 } }}>
                        <SiteAutocomplete
                            isRequired
                            selectSite={handleSelectSite}
                            sites={sites ?? []}
                            selectedSiteId={undefined}
                            title="Skladište"
                        />
                    </Box>
                </DialogContent>
            </ResponsiveDialog>
        </div>
    );
}
